import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type AccountType = 'pending' | 'verified' | 'linked' | 'moderator' | 'suspended' | 'banned';

export interface Profile {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  property_address: string;
  phone?: string;
  account_type: AccountType;
  is_verified: boolean;
  is_anonymous_default: boolean;
  suspension_end_date?: string;
  created_at: string;
  updated_at: string;
}
